import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, setBlockTracking as _setBlockTracking, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "card" };
const _hoisted_2 = {
    key: 0,
    class: "px-3 lg:px-4 pt-3 pb-2"
};
const _hoisted_3 = { class: "flex justify-between items-center" };
const _hoisted_4 = { class: "font-semibold" };
const _hoisted_5 = ["aria-label", "title"];
const _hoisted_6 = { class: "my-1 text-muted collapsible-content" };
const _hoisted_7 = { class: "grid grid-cols-2 lg:grid-cols-4 gap-4 px-3 lg:px-4 pb-3 lg:pb-4" };
const _hoisted_8 = ["textContent"];
const _hoisted_9 = { class: "text-muted text-sm" };
const _hoisted_10 = ["textContent"];
const _hoisted_11 = ["textContent"];
const _hoisted_12 = ["textContent"];
const _hoisted_13 = { class: "text-muted text-sm" };
const _hoisted_14 = ["textContent"];
const _hoisted_15 = ["textContent"];
const _hoisted_16 = { class: "font-normal text-2xl" };
const _hoisted_17 = ["textContent"];
const _hoisted_18 = { class: "text-muted text-sm" };
const _hoisted_19 = ["textContent"];
const _hoisted_20 = ["textContent"];
const _hoisted_21 = { key: 0 };
const _hoisted_22 = { class: "font-normal text-2xl" };
const _hoisted_23 = ["textContent"];
const _hoisted_24 = { class: "text-muted text-sm" };
const _hoisted_25 = ["textContent"];
const _hoisted_26 = ["textContent"];
import { computed, ref } from 'vue';
import { ___, toFixedNumberStrWithFallback } from '@ts/common/language';
import SvgVue from '@ts/components/utils/SvgVue.vue';
import {} from '@ts/common/datasets';
export default /*@__PURE__*/ _defineComponent({
    __name: 'CompareFat',
    props: {
        dataA: { default: undefined },
        dataB: { default: undefined },
        help: { type: Boolean, default: false },
        header: { type: Boolean, default: true }
    },
    setup(__props) {
        const props = __props;
        const showHelp = ref(false);
        const fatmaxAbs = computed(() => {
            const value = props.dataA === undefined || props.dataB === undefined ? undefined : -100.0 * (1.0 - props.dataA.fatmax_abs / props.dataB.fatmax_abs);
            return {
                value: value,
                string: toFixedNumberStrWithFallback(value, 1),
                stringA: toFixedNumberStrWithFallback(props.dataA?.fatmax_abs, 0),
                stringB: toFixedNumberStrWithFallback(props.dataB?.fatmax_abs, 0),
                class: value && value > 0 ? 'text-emerald-500' : value && value < 0 ? 'text-red-500' : '',
            };
        });
        const fatmaxRel = computed(() => {
            const value = props.dataA === undefined || props.dataB === undefined ? undefined : -100.0 * (1.0 - props.dataA.fatmax_rel / props.dataB.fatmax_rel);
            return {
                value: value,
                string: toFixedNumberStrWithFallback(value, 1),
                stringA: toFixedNumberStrWithFallback(props.dataA?.fatmax_rel, 2),
                stringB: toFixedNumberStrWithFallback(props.dataB?.fatmax_rel, 2),
                class: value && value > 0 ? 'text-emerald-500' : value && value < 0 ? 'text-red-500' : '',
            };
        });
        const fatmaxPercVo2max = computed(() => {
            const value = props.dataA === undefined || props.dataB === undefined ? undefined : -100.0 * (1.0 - props.dataA.fatmax_perc_v02max / props.dataB.fatmax_perc_v02max);
            return {
                value: value,
                string: toFixedNumberStrWithFallback(value, 1),
                stringA: toFixedNumberStrWithFallback(props.dataA?.fatmax_perc_v02max, 0),
                stringB: toFixedNumberStrWithFallback(props.dataB?.fatmax_perc_v02max, 0),
            };
        });
        const heartrateFatmax = computed(() => {
            const value = props.dataA === undefined ||
                props.dataB === undefined ||
                props.dataA.heartrate_c0 === null ||
                props.dataB.heartrate_c0 === null ||
                props.dataA.heartrate_c1 === null ||
                props.dataB.heartrate_c1 === null
                ? undefined
                : -100.0 * (1.0 - (props.dataA.heartrate_c0 * props.dataA.fatmax_abs + props.dataA.heartrate_c1) / (props.dataB.heartrate_c0 * props.dataB.fatmax_abs + props.dataB.heartrate_c1));
            const valueA = props.dataA === undefined || props.dataA.heartrate_c0 === null || props.dataA.heartrate_c1 === null
                ? undefined
                : props.dataA.heartrate_c0 * props.dataA.fatmax_abs + props.dataA.heartrate_c1;
            const valueB = props.dataB === undefined || props.dataB.heartrate_c0 === null || props.dataB.heartrate_c1 === null
                ? undefined
                : props.dataB.heartrate_c0 * props.dataB.fatmax_abs + props.dataB.heartrate_c1;
            return {
                value: value,
                string: toFixedNumberStrWithFallback(value, 1),
                stringA: toFixedNumberStrWithFallback(valueA, 0),
                stringB: toFixedNumberStrWithFallback(valueB, 0),
            };
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", _hoisted_1, [
                    (__props.header)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(___)({ en: 'Max. Fat Metabolsim', de: 'Max. Fettverbrennung' })), 1 /* TEXT */),
                                (__props.help)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        onClick: _cache[1] || (_cache[1] = ($event) => (showHelp.value = !showHelp.value)),
                                        type: "button",
                                        class: "btn text-gray-350 dark:text-gray-450 hover:text-primary-500",
                                        "aria-label": _unref(___)({ en: 'Toggle help', de: 'Hilfe ein- und ausblenden' }),
                                        title: _unref(___)({ en: 'Help', de: 'Hilfe' })
                                    }, [
                                        _cache[0] || (_setBlockTracking(-1, true),
                                            (_cache[0] = _createVNode(SvgVue, {
                                                class: "w-4 h-4",
                                                icon: "lucide/circle-question-mark"
                                            })).cacheIndex = 0,
                                            _setBlockTracking(1),
                                            _cache[0])
                                    ], 8 /* PROPS */, _hoisted_5))
                                    : _createCommentVNode("v-if", true)
                            ]),
                            (__props.help)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: _normalizeClass(["collapsible", showHelp.value ? 'expanded' : ''])
                                }, [
                                    _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(___)({
                                        en: 'The power at maximum fat burning (Fatmax) indicates the power at which the body utilizes the largest amount of fat.',
                                        de: 'Die Leistung bei maximale Fettverbrennung (Fatmax) gibt die Leistung weiter, bei welcher der Körper die größte Menge an Fetten verwertet.',
                                    })), 1 /* TEXT */)
                                ], 2 /* CLASS */))
                                : _createCommentVNode("v-if", true)
                        ]))
                        : _createCommentVNode("v-if", true),
                    _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", null, [
                            _createElementVNode("div", null, _toDisplayString(_unref(___)({
                                en: 'Absolute fatmax power',
                                de: 'Absolute Leistung bei max. Fettverbrennung',
                            })), 1 /* TEXT */),
                            _createElementVNode("div", {
                                class: _normalizeClass(["font-normal text-2xl", fatmaxAbs.value.class])
                            }, [
                                _createElementVNode("span", {
                                    textContent: _toDisplayString(fatmaxAbs.value.string)
                                }, null, 8 /* PROPS */, _hoisted_8),
                                _cache[2] || (_cache[2] = _createTextVNode(" %", -1 /* CACHED */))
                            ], 2 /* CLASS */),
                            _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("span", {
                                    textContent: _toDisplayString(fatmaxAbs.value.stringA)
                                }, null, 8 /* PROPS */, _hoisted_10),
                                _cache[3] || (_cache[3] = _createTextVNode(" vs. ", -1 /* CACHED */)),
                                _createElementVNode("span", {
                                    textContent: _toDisplayString(fatmaxAbs.value.stringB)
                                }, null, 8 /* PROPS */, _hoisted_11),
                                _cache[4] || (_cache[4] = _createTextVNode(" W", -1 /* CACHED */))
                            ])
                        ]),
                        _createElementVNode("div", null, [
                            _createElementVNode("div", null, _toDisplayString(_unref(___)({
                                en: 'Relative fatmax power',
                                de: 'Relative Leistung bei max. Fettverbrennung',
                            })), 1 /* TEXT */),
                            _createElementVNode("div", {
                                class: _normalizeClass(["font-normal text-2xl", fatmaxRel.value.class])
                            }, [
                                _createElementVNode("span", {
                                    textContent: _toDisplayString(fatmaxRel.value.string)
                                }, null, 8 /* PROPS */, _hoisted_12),
                                _cache[5] || (_cache[5] = _createTextVNode(" %", -1 /* CACHED */))
                            ], 2 /* CLASS */),
                            _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("span", {
                                    textContent: _toDisplayString(fatmaxRel.value.stringA)
                                }, null, 8 /* PROPS */, _hoisted_14),
                                _cache[6] || (_cache[6] = _createTextVNode(" vs. ", -1 /* CACHED */)),
                                _createElementVNode("span", {
                                    textContent: _toDisplayString(fatmaxRel.value.stringB)
                                }, null, 8 /* PROPS */, _hoisted_15),
                                _cache[7] || (_cache[7] = _createTextVNode(" W/kg", -1 /* CACHED */))
                            ])
                        ]),
                        _createElementVNode("div", null, [
                            _createElementVNode("div", null, _toDisplayString(_unref(___)({ en: 'Utilization of the ', de: 'Ausnutzung der ' })) + " VO2max", 1 /* TEXT */),
                            _createElementVNode("div", _hoisted_16, [
                                _createElementVNode("span", {
                                    textContent: _toDisplayString(fatmaxPercVo2max.value.string)
                                }, null, 8 /* PROPS */, _hoisted_17),
                                _cache[8] || (_cache[8] = _createTextVNode(" %", -1 /* CACHED */))
                            ]),
                            _createElementVNode("div", _hoisted_18, [
                                _createElementVNode("span", {
                                    textContent: _toDisplayString(fatmaxPercVo2max.value.stringA)
                                }, null, 8 /* PROPS */, _hoisted_19),
                                _cache[9] || (_cache[9] = _createTextVNode(" vs. ", -1 /* CACHED */)),
                                _createElementVNode("span", {
                                    textContent: _toDisplayString(fatmaxPercVo2max.value.stringB)
                                }, null, 8 /* PROPS */, _hoisted_20),
                                _cache[10] || (_cache[10] = _createTextVNode(" %", -1 /* CACHED */))
                            ])
                        ]),
                        (heartrateFatmax.value.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                _createElementVNode("div", null, _toDisplayString(_unref(___)({
                                    en: 'Heart rate',
                                    de: 'Herzfrequenz',
                                })), 1 /* TEXT */),
                                _createElementVNode("div", _hoisted_22, [
                                    _createElementVNode("span", {
                                        textContent: _toDisplayString(heartrateFatmax.value.string)
                                    }, null, 8 /* PROPS */, _hoisted_23),
                                    _cache[11] || (_cache[11] = _createTextVNode(" %", -1 /* CACHED */))
                                ]),
                                _createElementVNode("div", _hoisted_24, [
                                    _createElementVNode("span", {
                                        textContent: _toDisplayString(heartrateFatmax.value.stringA)
                                    }, null, 8 /* PROPS */, _hoisted_25),
                                    _cache[12] || (_cache[12] = _createTextVNode(" vs. ", -1 /* CACHED */)),
                                    _createElementVNode("span", {
                                        textContent: _toDisplayString(heartrateFatmax.value.stringB)
                                    }, null, 8 /* PROPS */, _hoisted_26),
                                    _cache[13] || (_cache[13] = _createTextVNode(" bpm", -1 /* CACHED */))
                                ])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ])
                ])
            ]));
        };
    }
});
